<template>
	<div class="page" :style="{'width':width,'height':height,'left':left,'top':top}">
		<slot></slot>
	</div>
</template>


<style scoped>
	.page {
		position: absolute;
		background-color: white;
		overflow: hidden;
	}
</style>


<script>
	export default {
		props: {
			containerWidth: {
				type: Number,
				default: function() {
					return document.documentElement.clientWidth
				}
			},
			containerHeight: {
				type: Number,
				default: function() {
					return document.documentElement.clientHeight
				}
			},
			direction: {
				type: Number,
				default: function() {
					return 1
				}
			},
			ratio: {
				type: Number,
				default: function() {
					return 0
				}
			},
		},
		data() {
			return {
				width: 0,
				height: 0,
				left: 0,
				top: 0,
			};
		},
		mounted() {
			this.checkDirection()
		},
		watch: {
			containerWidth() {
				this.checkDirection()
			},
			containerHeight() {
				this.checkDirection()
			}
		},
		methods: {
			vertical() {
				let height = this.containerWidth * (this.ratio == 0 ? 2.08 : this.ratio)
				
				this.width = this.containerWidth + 'px'
				this.height = height + 'px'
				this.left = '0%'
				this.top = (this.containerHeight - height) / 2 + 'px'
				if (this.containerWidth != this.$store.state.maxWidth || height != this.$store.state.maxHeight) {
					this.$store.commit('setMaxSize', {
						width: this.containerWidth,
						height: height
					})
				}
			},
			horizontal() {
				//let width = this.containerHeight * 2.18;
				let width = this.containerHeight * (this.ratio == 0 ? 1.94 : this.ratio)
				this.width = width + 'px'
				this.height = this.containerHeight + 'px'
				this.left = (this.containerWidth - width) / 2 + 'px'
				this.top = 0
				if (width != this.$store.state.maxWidth || this.containerHeight != this.$store.state.maxHeight) {
					this.$store.commit('setMaxSize', {
						width: width,
						height: this.containerHeight
					})
				}

			},
			checkDirection() {
				
				if (this.direction == 1) {
					this.vertical()
				} else {
					this.horizontal()
				}
			}


		},

	}
</script>
